import { InputField } from '@/components/Form';
import { MAX_SEARCH_KEYWORD_LENGTH } from '@/config';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/16/solid';
import { useTranslation } from 'react-i18next';

type SearchFieldProps = {
  value?: string;
  onSearch: (value: string | undefined) => void;
  leftIcon?: React.ReactNode;
  onValueChange: (value: string) => void;
  placeholder?: string;
};

export const SearchField = ({
  value,
  onSearch,
  leftIcon,
  onValueChange,
  placeholder,
}: SearchFieldProps) => {
  const { t } = useTranslation();
  const runSearch = (nextValue: string | undefined) => {
    const normalizedValue = nextValue?.trim();
    onSearch(normalizedValue ? normalizedValue : undefined);
  };

  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    runSearch(value ?? '');
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onValueChange(e.target.value);
  };

  const handleClear = () => {
    onValueChange('');
    runSearch(undefined);
  };

  return (
    <form onSubmit={handleOnSubmit}>
      <InputField
        type="text"
        name="search-query"
        className="border-2 pr-20 shadow-none"
        rounded="3xl"
        leftIcon={leftIcon}
        icon={
          <div className="flex items-center gap-1">
            {value && (
              <button
                type="button"
                onClick={handleClear}
                aria-label={t('クリア')}
                className="rounded-3xl p-1 text-gray-500 hover:text-gray-700"
              >
                <XMarkIcon className="size-5" />
              </button>
            )}
            <button
              type="submit"
              className="rounded-3xl bg-primary-dark-teal px-2 py-0.5 text-white"
            >
              <MagnifyingGlassIcon className="size-6" />
            </button>
          </div>
        }
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder ?? t('検索')}
        maxLength={MAX_SEARCH_KEYWORD_LENGTH}
      />
    </form>
  );
};
